var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCalling)?_c('video-call-room-container',{attrs:{"user":_vm.user,"isCaller":_vm.isCaller,"occupationCode":_vm.occupationCode,"occupationShortName":_vm.occupationShortName},on:{"destroyed":_vm.handleDestroyed},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var user = ref.user;
var participants = ref.participants;
var mainScreenParticipant = ref.mainScreenParticipant;
var handleHangUp = ref.handleHangUp;
var handleChangeMainScreen = ref.handleChangeMainScreen;
return [_vm._t("videoCallRoom",null,{"user":user,"participants":participants,"mainScreenParticipant":mainScreenParticipant,"handleHangUp":handleHangUp,"handleChangeMainScreen":handleChangeMainScreen})]}}],null,true)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }